if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector(".js-product-form");
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector("cart-drawer");
        this.submitBtn = this.getSubmitButton();

        if (theme.settings.afterAtc !== "no-js") {
          this.submitBtn.addEventListener(
            "click",
            this.handleSubmit.bind(this)
          );
        }
      }
    }

    getSubmitButton() {
      if (this.dataset.proForm) {
        return this.closest(".js-pro-form").querySelector('[name="add"]');
      } else {
        return this.querySelector('[name="add"]');
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === "product-signup_form") return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute("aria-disabled") === "true") return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute("aria-disabled", "true");
      this.submitBtn.classList.add("is-loading");

      const formData = Object.fromEntries(new FormData(this.form));
      let isStack = false;
      let items = [];
      const isProForm = formData["sf-pro"] === "true";

      if (!isProForm) {
        const bundleChildrenWrapper = document.querySelector("bundle-children");

        // Check for stack items and add-ons
        if (bundleChildrenWrapper) {
          const visibleBundleChildren = bundleChildrenWrapper.querySelectorAll(
            '.js-bundle-child-wrapper[data-visible="true"]'
          );

          visibleBundleChildren.forEach((x) => {
            if (x.dataset.bundleType === "S") {
              isStack = true;
            }

            const children = x.querySelectorAll("bundle-child-variant-picker");

            if (children) {
              const additionalItems = Array.from(children)
                .map((child) =>
                  child.variant
                    ? {
                        id: child.variant.id,
                        quantity: formData.quantity,
                      }
                    : null
                )
                .filter(Boolean);
              items = [...items, ...additionalItems];
            }
          });
        }
      }

      const sellingPlanId = formData["selling-plan-id"] || null;
      const itemsToAdd = isStack ? items : [{
        id: formData.id,
        quantity: formData.quantity,
        ...(sellingPlanId
          ? { selling_plan: sellingPlanId }
          : {}),
      }].concat(items);
      const body = {
        form_type: "product",
        utf: "✓",
        "section-id": formData["section-id"],
        items: isStack
          ? items.reverse()
          : [
              {
                id: formData.id,
                quantity: formData.quantity,
                ...(sellingPlanId
                  ? { selling_plan: sellingPlanId }
                  : {}),
              },
            ].concat(items),
      };

      let sections = "cart-icon-bubble";
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer
          .closest(".shopify-section")
          .id.replace("shopify-section-", "")}`;
      }

      body.sections_url = window.location.pathname;
      body.sections = sections;

      const fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error =
          typeof data.description === "string"
            ? data.description
            : data.message;
        if (data.errors && typeof data.errors === "object") {
          error = Object.entries(data.errors).map((item) => item[1].join(", "));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === "page") {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest("quick-add-drawer");
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === "drawer"
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector("cart-items");
              if (cartItems) {
                if (cartItems.dataset.empty === "true") {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(
            new CustomEvent("on:line-item:change", {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
                oldQuantity: itemInOldCart.quantity,
                newQuantity:
                  itemInOldCart.quantity === data.quantity
                    ? itemInOldCart.quantity
                    : data.quantity,
              },
            })
          );
        } else {
          this.dispatchEvent(
            new CustomEvent("on:cart:add", {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
              },
            })
          );
        }

        if (data?.items?.length) {
          gg.sendEvent({
            data: {
              variants: itemsToAdd.map(item => {
                const updatedItem = data.items.find(x => String(x.variant_id) === String(item.id));

                if (!updatedItem) return false
                
                return ({
                  id: updatedItem.sku || '',
                  name: `${updatedItem.product_title} - ${updatedItem.variant_title}`,
                  brand: updatedItem.vendor,
                  category: updatedItem.product_type,
                  variant: updatedItem.variant_title,
                  price: updatedItem.price,
                  quantity: item.quantity,
                  productId: updatedItem.product_id,
                  variantId: updatedItem.variant_id,
                  compareAtPrice: updatedItem.original_price,
                  image: updatedItem.image
                });
              }).filter(Boolean)
            },
            type: gg.eventTypes.CART_ADD
          });
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(
          new CustomEvent("on:cart:error", {
            bubbles: true,
            detail: {
              error: this.errorMsg?.textContent,
            },
          })
        );

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add("is-success");
        this.submitBtn.removeAttribute("aria-disabled");

        document.dispatchEvent(
          new CustomEvent("on:cart:after-add", {
            bubbles: true,
            detail: {
              isProModal: this.dataset.proForm === "true",
            },
          })
        );

        setTimeout(() => {
          this.submitBtn.classList.remove("is-loading");
          this.submitBtn.classList.remove("is-success");
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById("cart-icon-bubble");
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections["cart-icon-bubble"];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector(".js-form-error");
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = "";
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML("beforeend", "<br>");
          this.errorMsg.insertAdjacentText("beforeend", err);
        });
      }
    }
  }

  customElements.define("product-form", ProductForm);
}
